export default __webpack_public_path__ + "static/performance-67e24577f26c92ab22d8fe2d9a99b3ec.jpg";